import React, { useEffect, useState } from "react";
import { APP_VERSION } from "../../version";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../../src/style.css";
import "../redirect_portal/redirect_style.css";
import { toast } from "react-toastify";
import axios from "axios";
import socketIOClient from "socket.io-client";
import { useSelector } from "react-redux";
import Navbar from "./Navbar";
import { Dropdown } from "react-bootstrap";
import LiveCall from "../../pages/LiveCall";
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import NightlightIcon from "@mui/icons-material/Nightlight";
import MenuIcon from "@mui/icons-material/Menu";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CallIcon from "@mui/icons-material/Call";
import { api } from "../../mockData";
import Sidebar from "./Sidebar";

// Custom inline SVG — male operator with headset. MUI's SupportAgentIcon
// reads gender-neutral; user wanted explicitly male. Key signifiers: short
// flat-top hair, squared jaw, broader shoulders, prominent headset + mic.
// viewBox 0 0 64 64 so the SVG scales cleanly to any size we pass.
const MaleOperatorIcon = ({ size = 36, color = "#fff" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Headset band arching over the head */}
    <path
      d="M13 32 v-4 c0 -10.5 8.5 -19 19 -19 s 19 8.5 19 19 v4"
      stroke={color}
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
    {/* Short flat-top hair — masculine cut */}
    <path
      d="M21 27 c0 -6 5 -11 11 -11 s 11 5 11 11 v1 c-2.5 -2.5 -7 -3 -11 -3 s -8.5 0.5 -11 3 z"
      fill={color}
    />
    {/* Face / head — slightly squared jaw for male read */}
    <path
      d="M22 28 c0 7 4.5 13 10 13 s 10 -6 10 -13 v-1 H22 z"
      fill={color}
    />
    {/* Left earcup */}
    <rect x="9" y="29" width="7" height="10" rx="2" fill={color} />
    {/* Right earcup */}
    <rect x="48" y="29" width="7" height="10" rx="2" fill={color} />
    {/* Mic boom curving from right earcup down toward the mouth */}
    <path
      d="M52 39 Q52 46 42 49"
      stroke={color}
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
    />
    {/* Mic capsule at the end of the boom */}
    <circle cx="41" cy="49" r="2.2" fill={color} />
    {/* Broad shoulders / collar */}
    <path
      d="M10 62 c0 -9 7 -16 16 -16 h12 c9 0 16 7 16 16 v2 H10 z"
      fill={color}
    />
  </svg>
);

function Header({ userThem, handleClickUser, toggleDrawer, open, setOpen }) {
  const [number, setNumber] = useState(0);
  const [minutest, setMinutest] = useState([]);
  const [indiaTime, setIndiaTime] = useState("");
  const [usaTime, setUsaTime] = useState("");
  const current_user = localStorage.getItem("current_user");
  const user = JSON.parse(localStorage.getItem(`user_${current_user}`));
  const navigate = useNavigate();

  useEffect(() => {
    const socket = socketIOClient(`${api.dev}`);

    // Get the current user information from localStorage
    const current_user = localStorage.getItem("current_user");
    const user = JSON.parse(localStorage.getItem(`user_${current_user}`));

    // Listen for events from the server
    socket.on("call_details", (data) => {
      // Handle the received data (e.g., update state, trigger a re-fetch)
      if (data?.data !== undefined) {
        // Filter the data based on UserId matching user.uid
        const filteredData = Object.keys(data?.data)
          .map((key) => {
            try {
              const parsedValue = JSON.parse(data?.data[key]); // Parse JSON string
              return {
                id: key, // Add the key as 'id'
                ...parsedValue, // Spread the parsed object
              };
            } catch (error) {
              console.error(`Failed to parse JSON for key: ${key}`, error);
              return null; // Return null or handle error as needed
            }
          })
          .filter(Boolean) // Filter out any null entries
          .filter((row) => row.UserId === user.uid); // Filter rows where UserId matches userId.uid

        // Get the count of filtered objects
        const newDataCount = filteredData.length;
        setNumber(newDataCount);
      }
    });

    return () => {
      // Disconnect the socket when the component unmounts
      socket.disconnect();
    };
  }, []); // Empty dependency array ensures this effect runs once on mount

  const logout = () => {
    // let data = JSON.stringify({
    //   "user_uuid": user?.user_uuid
    // });

    // let config = {
    //   method: 'post',
    //   maxBodyLength: Infinity,
    //   url: 'http://95.217.227.234:5000/logout',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   data : data
    // };

    // axios.request(config)
    // .then((res) => {
    //   if (res?.data?.message !== "") {
    toast.info("Logout Successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1500,
    });
    localStorage.removeItem("user");
    localStorage.removeItem("current_user");
    localStorage.removeItem("selectedTab");
    navigate("/");
    //   }
    // })
    // .catch((error) => {
    //   console.log(error);
    // });

    // axios
    //   .get("https://ikalyuga.com/api/index.php?action=logout", {})
    //   .then((res) => {
    //     if (res?.data?.response?.message !== "") {
    //       toast.info(res.data.response.message, {
    //         position: toast.POSITION.TOP_RIGHT,
    //         autoClose: 1500,
    //       });
    //       localStorage.removeItem("user");
    //       navigate("/");
    //     }
    //   });
  };

  const minutes = async () => {
    const current_user = localStorage.getItem("current_user");
    const token = JSON.parse(localStorage.getItem(`user_${current_user}`));
    try {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${api.dev}/api/userminute`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token} `,
        },
      };
      await axios
        .request(config)
        .then((response) => {
          setMinutest(response.data.data);
        })
        .catch((error) => {
          let errorMessage = "An error occurred while fetching data.";
          if (error.response) {
            if (error.response.status === 403) {
              errorMessage = "Permission Denied";
            } else if (
              error.response.status === 400 ||
              error.response.status === 401 ||
              error.response.status === 500
            ) {
              errorMessage = error.response.data.message || "Bad Request";
            }
          }
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    minutes();
  }, []);

  useEffect(() => {
    const updateTime = () => {
      const india = new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      const usa = new Date().toLocaleString("en-US", {
        timeZone: "America/New_York", // EST / EDT auto handle
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      setIndiaTime(india);
      setUsaTime(usa);
    };

    updateTime();
    const timer = setInterval(updateTime, 1000);

    return () => clearInterval(timer);
  }, []);

  const refershLogo = () => {
    window.location.href = "/redirect_portal";
  };

  return (
    <>
      <div className={`App ${userThem} `}>
        <div className="contant_box">
          <Box sx={{ flexGrow: 1 }} className={`App ${userThem} manage_boxx`}>
            <Box className="manage_mobile_logo d-lg-none d-md-none d-sm-block d-block">
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1 }}
                style={{ width: "100%" }}
                className="d-flex align-items-center logo_image d-lg-none d-md-none d-sm-block d-block text-center"
              >
                <span className="tellipsis-logo-wrap" style={{ margin: "auto" }}>
                  <img
                    src="/img/logo_white11.png"
                    alt="Manage Logo"
                    className="img-fluid d-block admin_logo"
                    style={{ cursor: "pointer" }}
                    onClick={refershLogo}
                  />
                  <span className="tellipsis-version-badge">{APP_VERSION}</span>
                </span>
                <IconButton
                  style={{ position: "relative", zIndex: 999, top: "-40px" }}
                  className="menu_icon_button"
                  onClick={toggleDrawer(true)}
                >
                  <MenuIcon />
                </IconButton>
              </Typography>
            </Box>

            <AppBar position="static" className="manage_top_header">
              <Toolbar>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1 }}
                  className="d-flex align-items-center d-xxl-block d-xl-block d-lg-block d-md-block d-sm-none d-none"
                >
                  {/* <img
                  src="/img/Tellepsis-green.png"
                  alt="Manage Logo"
                  className="img-fluid d-block"
                  style={{ cursor: "pointer", }}
                  onClick={refershLogo}
                /> */}
                  <Grid container>
                    <Grid item xs={12} sm={12} md={4}>
                      <a
                        href="/redirect_portal"
                        className="tellipsis-logo-wrap"
                        style={{ maxWidth: "auto" }}
                      >
                        {userThem === "user_theme_white" ? (
                          <>
                            {" "}
                            <img
                              src="/img/logo_white11.png"
                              alt="Manage Logo"
                              className="img-fluid d-block admin_logo"
                              style={{ cursor: "pointer" }}
                            />
                          </>
                        ) : (
                          <>
                            <img
                              // src="/img/logo-4-edit-1.png"
                              src="/img/Tellepsis-green.png"
                              alt="Manage Logo"
                              className="img-fluid d-block admin_logo"
                              style={{ cursor: "pointer" }}
                            />
                          </>
                        )}
                        <span className="tellipsis-version-badge">{APP_VERSION}</span>
                      </a>
                    </Grid>
                  </Grid>
                </Typography>

                <div className="manage_rgiht_bdr d-flex align-items-center">
                  <Box
                    sx={{
                      alignItems: "center",
                      gap: 1,
                      display: "flex",
                      flexWrap: { xs: "wrap", sm: "nowrap" },
                      width: "min-content",
                    }}
                  >
                    {/* IST */}
                    <Typography
                      sx={{
                        fontSize: { xs: "11px", sm: "13px" },
                        fontWeight: 600,
                        color: "#0f172a",
                        background: "#e0f2fe",
                        px: { xs: 1, sm: 1.5 },
                        py: 0.4,
                        borderRadius: "6px",
                        textTransform: "uppercase",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Box
                        component="span"
                        sx={{ display: { xs: "none", sm: "inline" } }}
                      >
                        IST:
                      </Box>
                      <Box
                        component="span"
                        sx={{ display: { xs: "inline", sm: "none" } }}
                      >
                        IST
                      </Box>
                      &nbsp;{indiaTime}
                    </Typography>

                    {/* EST */}
                    <Typography
                      sx={{
                        fontSize: { xs: "11px", sm: "13px" },
                        fontWeight: 600,
                        color: "#1e293b",
                        background: "#fff7ed",
                        px: { xs: 1, sm: 1.5 },
                        py: 0.4,
                        borderRadius: "6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Box
                        component="span"
                        sx={{ display: { xs: "none", sm: "inline" } }}
                      >
                        EST:
                      </Box>
                      <Box
                        component="span"
                        sx={{ display: { xs: "inline", sm: "none" } }}
                      >
                        EST
                      </Box>
                      &nbsp;{usaTime}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      alignItems: "center",
                      gap: "1",

                    }}
                  >
                    {/* Amount */}
                    <p
                      className="d-block d-lg-block d-md-block d-sm-none d-none"
                      style={{
                        color: "#000",
                        textTransform: "capitalize",
                        margin: 0,

                        // responsive
                        fontSize: window.innerWidth < 600 ? "12px" : "14px",
                      }}
                    >
                      <AttachMoneyIcon
                        className="call_icon"
                        style={{
                          fontSize: window.innerWidth < 600 ? "16px" : "20px",
                          marginBottom: "3px",
                          color: "#fc0d03",
                        }}
                      />

                      <span
                        style={{
                          fontSize: window.innerWidth < 600 ? "14px" : "17px",
                          fontWeight: 600,
                          marginLeft: "-3px",
                          color: "#f6873b",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {user.amount ? user.amount : "0.00"}
                      </span>
                    </p>

                    {/* Balance */}
                    <p
                      className="balance_text"
                      style={{
                        color: "#000",
                        textTransform: "capitalize",
                        marginBottom: "0px",
                        marginLeft: "10px",
                        fontSize: window.innerWidth < 600 ? "12px" : "14px",

                      }}
                    >
                      Balance{" "}
                      <span
                        style={{
                          fontSize: window.innerWidth < 600 ? "14px" : "17px",
                          fontWeight: 600,
                          color: "#00f500",
                        }}
                      >
                        {minutest[0]?.remaining_minutes}
                      </span>
                    </p>
                  </Box>


                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    className="manage_call"
                    sx={{
                      paddingRight: 0,

                      position: { xs: "absolute", md: "relative" },
                      bottom: { xs: "60px", md: "auto" },
                      right: { xs: "70px", md: "auto" },
                      zIndex: 1300,
                    }}
                  >
                    <CallIcon className="call_icon" />
                    <div>
                      <sub
                        style={{
                          color: { xs: "#fff", md: "#000" },
                          textTransform: "capitalize",
                          fontSize: "14px",
                        }}
                        className="live_icon"
                      >
                        {number}
                      </sub>
                    </div>
                    <Box sx={{ color: { xs: "#fff", md: "#000" }, }}>Live</Box>
                    {/* <LiveCall /> */}
                  </IconButton>

                  {/* Dark-mode */}

                  <div className="theme_options">
                    {userThem === "user_theme_white" ? (
                      <>
                        <Tooltip
                          title="Light Theme"
                        >
                          <IconButton
                            onClick={() => handleClickUser("user_theme_dark")}
                          >
                            {" "}
                            <DarkModeIcon
                              id="user_theme_white"
                              className={`${userThem === "user_theme_white" ? "active" : ""
                                }`}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        <Tooltip
                          title="Dark Theme"
                        >
                          <IconButton
                            onClick={() => handleClickUser("user_theme_white")}
                          >
                            {" "}
                            <NightlightIcon
                              id="user_theme_dark"
                              style={{ color: "#f5751D " }}
                              className={`${userThem === "user_theme_white" ? "active" : ""
                                } fa-solid fa-moon`}
                            />
                          </IconButton>
                        </Tooltip>{" "}
                      </>
                    )}
                  </div>


                  <div className="dshbrd_hdr_icon">
                    <ul className="hdr_profile">
                      <li>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Tooltip title={user?.user_name || "Account"} arrow>
                            <Avatar
                              sx={{
                                width: 44,
                                height: 44,
                                // Brand-aligned orange gradient — keeps
                                // continuity with the orange accents used
                                // elsewhere on the user portal.
                                background:
                                  "linear-gradient(135deg, #f5751D 0%, #c2410c 100%)",
                                color: "#fff",
                                border: "2px solid #fff",
                                boxShadow:
                                  "0 2px 10px rgba(245, 117, 29, 0.35)",
                                cursor: "default",
                                // Override MUI Avatar's default 0.5em padding
                                // so the SVG fills the full circle.
                                "& > svg": { width: "78%", height: "78%" },
                              }}
                            >
                              <MaleOperatorIcon color="#fff" />
                            </Avatar>
                          </Tooltip>
                          <div
                            className="profile_name"
                            style={{ paddingLeft: "0px", marginLeft: "0px" }}
                          >
                            <b style={{ color: "#000" }}>{user?.user_name}</b>
                          </div>
                        </Box>
                      </li>

                      <li>
                        <IconButton
                          size="large"
                          aria-label="account of current user"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          style={{ paddingRight: "0" }}
                          onClick={logout}
                        >
                          <PowerSettingsNewIcon className="call_icon " />
                        </IconButton>
                      </li>
                    </ul>
                  </div>
                </div>
              </Toolbar>
            </AppBar>
            {/* <!--navbar-sec--> */}
            <div className="d-xxl-block d-xl-block d-lg-block d-md-block d-sm-none d-xs-none d-none">
              <Navbar />
            </div>

            {/* ====mobile sidebar===== */}
            <div className="d-xxl-none d-xl-none d-lg-none d-md-none d-sm-block d-xs-block d-block">
              <Sidebar open={open} setOpen={setOpen} onLogout={logout} />
            </div>
          </Box>
        </div>
      </div>
    </>
  );
}

export default Header;
